import "./myProfileDocumentationContractView.scss"

import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Immutable from "immutable"
import PropTypes from "prop-types"
import React from "react"
import { i18n } from "core/i18n"

const { formatText, FormattedText, formatTextApi, getFinalTitle } = i18n
import { OKCover } from "commonsComponents/OKCover"
import { OKHeaderSubPage } from "commonsComponents/OKHeaderSubPage"
import OKInformativeList from "components/rebrand/OKInformativeList/OKInformativeList"
import OKInformativeListItem from "components/rebrand/OKInformativeListItem/OKInformativeListItem"
import { OKSectionBox } from "commonsComponents/OKSectionBox"
import { LoadingSection } from "commonsComponents/loadingSection"
import { OKLink } from "commonsComponents/OKLink"
import { EmptyState } from "commonsComponents/emptyState"
import DocumentsTable from "components/myProfile/documentsTable/documentsTable"
import * as depositsActions from "actions/deposits"
import * as saddeActions from "actions/sadde"
import * as okApiDocumentsActions from "actions/okApiDocuments"
import DateHelper from "utilities/dateHelper"
import { sortByOrder } from "lodash/collection"
import { GENERAL_DATA } from "constants/mortgageRequestMortgageDataTypes"

const { PRODUCT_NUMBER } = GENERAL_DATA
import { VIEWER } from "constants/contactCenter/pdfViewer"
import { CONTRACTUAL_TYPES } from "constants/contractualDocuments"
import {CONTRACT_TYPES} from "constants/contractType";

class MyProfileDocumentationContractView extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const {
            getCardsIban,
            getLoansIban,
            match: { params: { contractId, contractType } },
            requestDeposits,
            getContractualOverdraftProtection,
        } = this.props

        switch (contractType) {
            case "cards":
                getCardsIban({
                    contractId: contractId.replace(/\s+/g, "").trim(),
                    success: this.callbackSaddeDocuments.bind(this),
                })
                break
            case "loans":
                getLoansIban({
                    contractId: contractId.replace(/\s+/g, "").trim(),
                    success: this.callbackSaddeDocuments.bind(this),
                })
                break
            case "mortgages":
                getLoansIban({
                    contractId: contractId.replace(/\s+/g, "").trim(),
                    success: this.callbackSaddeDocuments.bind(this),
                })
                break
            case "pregrantedcredit":
            default:
                this.callbackSaddeDocuments(
                    this.getContractNumber(contractType)
                )
        }

        const contractNumber = this.getContractNumber(contractType)
        getContractualOverdraftProtection(contractNumber)
        this.getPreContracts(this.getDataByContractId())
        if (contractType === "deposits" && !this.props.immDeposits.get("byId")) {
            requestDeposits()
        }
    }

    getBreadCrumb(alias) {
        return [
            {
                text: formatText("breadcrumb-documentation"),
                url: "/myprofile/documentation/",
            },
            {
                text: formatText("breadcrumb-contracts"),
                url: "/myprofile/documentation/contracts",
            },
            {
                text: alias,
            },
        ]
    }

    getContractNumber(contractType) {
        const immData = this.getDataByContractId()
        const contractNumberByType = {
            account: ["ibanComplex", "codbban"],
            cards: ["fullContractNumber"],
            mortgages: ["fullContractNumber"],
            loans: ["newContractNumber"],
            wallet: ["fullContractNumber"],
            deposits: ["fullContractNumber"],
            pregrantedcredit: ["ibanComplex", "codbban"],
        }
        const contractNumber = immData.getIn(contractNumberByType[contractType]) || ""
        return contractNumber.replace(/\s+/g, "")
    }

    getCurrentDocumentTable() {
        const {  match: { params: { contractType } }, immSadde, immOkApiDocuments, getDocumentsOkApiById } = this.props
        let response
        let title = formatText("profileContract-preContractTitle")

        if (contractType === CONTRACT_TYPES.DEPOSITS) {
            return null
        }

        if (immSadde.get("isFetchingPrecontracts") || immOkApiDocuments.get("isFetchingPrecontracts")) {
            response = <LoadingSection />
        } else {
            const immSaddeTable = this.immutableCurrentDocumentTableData(
                immSadde.getIn(["precontracts", "response"]),
            )
            const immOkApiDocumentsTable = this.immutableCurrentOkApiDocumentTableData(
                immOkApiDocuments.getIn(["precontracts", "documents"]),
            )

            if (immSaddeTable.size > 0 || immOkApiDocumentsTable.size > 0) {
                if (immOkApiDocumentsTable.size > 0) {
                    response = (
                        <DocumentsTable
                            data={immOkApiDocumentsTable}
                            showAlias={false}
                            showCurrentDocument={false}
                            showDocumentationType={true}
                            linkSquare={true}
                            downloadById={getDocumentsOkApiById}
                        />
                    )
                } else if (immSaddeTable.size > 0) {
                    response = (
                        <DocumentsTable
                            data={immSaddeTable}
                            showAlias={false}
                            showCurrentDocument={false}
                            showDocumentationType={true}
                            linkSquare={true}
                            isContractsInForce
                        />
                    )
                }


            } else {
                response = `${formatText("profileContract-stillNoPrecontracts")}`
            }
        }

        return (
            <div>
                <div className='contract-view__contract'>
                    <h3 className='contract-view__title'>
                        {title}
                    </h3>
                    {response}
                </div>
            </div>
        )
    }

    getDataByContractId() {
        const { contractType, contractId } = this.props.match.params
        const { immAccounts, immCards, immCardsCanceled, immLoans, immWallets, immSavings } = this.props
        let immData

        switch (contractType) {
            case "account":
                immData = immAccounts
                .get("byId")
                .filter(account => account.getIn(["ibanComplex", "codbban"]) === contractId)
                .first()
                break
            case "cards":
                immData = immCards
                .get("byId")
                .filter(
                    card => card.get("number").replace(/\s+/g, "").trim() === contractId.trim(),
                )
                .first()
                if (!immData) {
                    immData = immCardsCanceled
                    .get("byId")
                    .filter(
                        card => card.get("number").replace(/\s+/g, "").trim() === contractId.trim(),
                    )
                    .first()
                }
                break
            case "loans":
                immData = immLoans
                .get("byId")
                .filter(immLoan => immLoan.get("loanId") === contractId)
                .first()
                break
            case "mortgages":
                immData = immLoans
                .get("byId")
                .filter(immLoan => immLoan.get("loanId") === contractId)
                .first()
                break
            case "wallet":
                immData = immWallets
                .filter(immWallet => immWallet.get("id") === contractId)
                .first()
                break
            case "pregrantedcredit":
                immData = immAccounts
                .get("byId")
                .filter(account => account.getIn(["iban"]) === contractId)
                .first()
                break
            case "deposits":
                immData = immSavings
                .filter(immSaving => immSaving.get("id") === contractId)
                .first()
                break
        }
        return immData
    }

    handleContractualAction = (params, filename) => {
        const {
            getFileSaddeDocuments,
            getDocumentsOkApiById,
            updateIsFetchingOverdraftInProgress,
            updateIsFetchingOverdraftFinish,
            match: { params: { contractId } },
        } = this.props
        const actionByFileType = {
            [CONTRACTUAL_TYPES.overdraft]: () => {
                const documentId = params.get("documentId")
                updateIsFetchingOverdraftInProgress({ documentId, contractId })
                getDocumentsOkApiById(documentId, () => updateIsFetchingOverdraftFinish({ documentId, contractId }))
            },
        }

        const fileAction = actionByFileType[params.get("type")]
        const defaultAction = () => getFileSaddeDocuments(params, filename, __CONTACT_CENTER__ && VIEWER)

        fileAction ? fileAction() : defaultAction()
    }

    generateDocumentsTableContent() {
        const { contractType, contractId } = this.props.match.params
        const { immSadde, immOkApiDocuments } = this.props

        if (immSadde.get("fetchingIbanError")) {
            return <EmptyState iconType='noitems-wealth' />
        }

        if (immSadde.get("isFetchingDocuments") || immOkApiDocuments.get("isFetchingOverDraftProtection")) {
            return <LoadingSection />
        }

        let immTable = this.immutableTableData(immSadde.get("documents"))
        if (contractType === "pregrantedcredit" && immTable.size) {
            immTable.find(singleDocument => {
                immTable = singleDocument.get("nombreTipoComunicacion").toLowerCase().includes("preconcedido") &&
                    Immutable.List([singleDocument])
                return immTable
            })
        }

        const overDraftDocuments = immOkApiDocuments.get("overDraftProtectionDocuments").get(contractId) || Immutable.fromJS([])
        if ((immTable && immTable.size) || (overDraftDocuments && overDraftDocuments.size)) {
            const data = Immutable.fromJS([
                ...overDraftDocuments.toJS(),
                ...immTable.toJS(),
            ])

            return (
                <DocumentsTable
                    data={data}
                    showAlias={false}
                    showCurrentDocument={true}
                    showDocumentationType={true}
                    callbackDownloadFile={this.handleContractualAction}
                    isContractsInForce={true}
                />
            )
        }

        return `${formatText("profileContract-stillNoContracts")}`
    }

    getPreContracts(immData) {
        const {
            getPreContractuals,
            getPreContractualsOkApi,
            match: { params: { contractType, contractId } },
        } = this.props
        let productType = immData.get("newProduct")
        let productSubtype = immData.get("productSubType")
        let standard = 1
        switch (contractType) {
            case "account":
                productSubtype = immData.get("accountType")
                break
            case "wallet":
                productType = immData.get("product")
                break
            case "deposits":
                productType = immData.get("product")
                productSubtype = immData.get("subTypeProduct")
                break
            case "cards":
                productType = immData.get("product").get("type")
                productSubtype = immData.get("productSubType")
                standard = immData.getIn(["product", "standard"])
                break
            case "pregrantedcredit":
                productType = 999
                productSubtype = 999
                break
        }

        const getOldPreContractual = () => getPreContractuals({
            standard,
            contractId: contractId.replace(/\s+/g, "").trim(),
            tipo: productType,
            subtipo: productSubtype,
        })

        const contractNumber = this.getContractNumber(contractType)
        getPreContractualsOkApi(getOldPreContractual, contractNumber)
    }

    buildDocumentationCenterItem() {
        const { match: { params: { contractType, contractId } } } = this.props
        const immData = this.getDataByContractId()

        let item

        if (contractType === "mortgages" && immData.get("product") === PRODUCT_NUMBER /*Hipoteca Open*/) {
            const documentsURL = `/myprofile/documentation/contracts/${contractType}/${contractId}/documents`
            item = (
                <div>
                    <h3 className='contract-view__title'>
                        <FormattedText value='profileContract-documentationCenter' />
                    </h3>
                    <OKLink
                        modifier='complementary'
                        to={documentsURL}
                    >
                        <FormattedText value='profileContract-viewDocuments' />
                    </OKLink>
                </div>
            )
        }

        return item
    }

    callbackSaddeDocuments(contractId) {
        this.props.getSaddeDocuments({
            contractId: contractId.replace(/\s+/g, "").trim(),
        })
    }

    immutableCurrentOkApiDocumentTableData(immDocuments) {
        let obj = []
        if (immDocuments) {
            immDocuments.forEach(immDocument => {
                obj.push({
                    fileExtension: immDocument.get("fileExtension"),
                    documentName: immDocument.get("documentName"),
                    applicationType: immDocument.get("applicationType"),
                    documentType: immDocument.get("documentType"),
                    documentId: immDocument.get("documentId"),
                    registrationDate: immDocument.get("registrationDate"),
                })
            })
        }
        return Immutable.fromJS(obj)
    }


    immutableCurrentDocumentTableData(immDocuments) {
        const { immSadde, match: { params: { contractType } } } = this.props
        const immData = this.getDataByContractId()
        let formattedOpeningDate
        let openingDate
        let obj = []

        function getFieldByProperty(immDocument, prop) {
            return immDocument.get("fields").find(field => field.get("name") === prop)
        }

        if (contractType === "cards") {
            if (immSadde.get("documents").size) {
                immSadde.get("documents").forEach(immDoc => {
                    const currentDate = getFieldByProperty(immDoc, "FECHADOCUM").get("value")

                    if (!openingDate || currentDate < openingDate) {
                        openingDate = currentDate
                        formattedOpeningDate = DateHelper.customFormat(
                            openingDate.substr(0, 4) +
                            "-" +
                            openingDate.substr(4, 2) +
                            "-" +
                            openingDate.substr(6, 2),
                        )
                    }
                })
            }
        } else {
            openingDate = contractType === "pregrantedcredit"
                ? DateHelper.customFormat(immData.get("openingDate"))
                : DateHelper.customFormat(immData.get("openingDate") || immData.get("situationDate"))
            formattedOpeningDate = openingDate
        }

        if (immDocuments) {
            immDocuments.forEach(immDocument => {
                if (formattedOpeningDate) {
                    const okFechaAlta = DateHelper.customFormat(immDocument.get("fechaAlta")) <= formattedOpeningDate
                    const okFechaBaja = DateHelper.customFormat(immDocument.get("fechaBaja")) >= formattedOpeningDate
                    if (okFechaBaja && okFechaAlta) {
                        let fechaAlta = openingDate

                        if (contractType === "pregrantedcredit" && immSadde.get("documents") && immSadde.get("documents").size) {
                            const tableData = this.immutableTableData(immSadde.get("documents"))
                            const currentDocument = tableData && tableData.find(doc => doc.get("currentDocument"))
                            fechaAlta = currentDocument.get("fechaAlta") && DateHelper.customFormat(currentDocument.get("fechaAlta"))
                        } else if (contractType === "cards") {
                            fechaAlta = immDocument.get("fechaAlta") && DateHelper.customFormat(immDocument.get("fechaAlta"))
                        }

                        obj.push({
                            fechaAlta,
                            url: immDocument.get("url"),
                            nombreTipoComunicacion: immDocument.get("descripcion"),
                        })
                    }
                }
            })
        }

        return Immutable.fromJS(obj)
    }

    immutableTableData(immDocuments) {
        let obj = []

        function getByProperty(immDocument, prop) {
            return immDocument.get("fields").filter(field => field.get("name") === prop).first()
        }

        if (immDocuments) {
            immDocuments.map(immDocument => {
                obj.push({
                    fechaAlta: getByProperty(immDocument, "FECHADOCUM").get("value"),
                    nombreTipoComunicacion: getByProperty(immDocument, "TIPCOMUNIC").get("value"),
                    file: {
                        process: immDocument.get("process"),
                        internalIdx: immDocument.get("internalIdx"),
                        segmentId: immDocument.get("segmentId"),
                        pageTo: immDocument.get("pageTo") || 0,
                        queryId: immDocument.get("queryId"),
                    },
                    isFetching: immDocument.get("isFetching") || false,
                })
            })

            obj = sortByOrder(
                obj,
                o => {
                    return o.fechaAlta
                },
                "desc",
            )

            if (obj[0]) {
                obj[0].currentDocument = true
            }
        }

        return Immutable.fromJS(obj)
    }

    render() {
        const { contractType } = this.props.match.params
        const immData = this.getDataByContractId()
        const subtitleHeaderByType = {
            account: ["alias"],
            cards: ["alias", "current"],
            mortgages: ["alias"],
            loans: ["alias"],
            wallet: ["name"],
            deposits: ["alias"],
        }

        const accountHolderByType = {
            account: ["accountHolder"],
            cards: ["titularName"],
            mortgages: ["loanHolder"],
            loans: ["loanHolder"],
            wallet: ["owner"],
            deposits: ["accountHolder"],
            pregrantedcredit: ["accountHolder"],
        }

        const interventionTypeByType = {
            account: ["interventionType"],
            cards: ["interventionType"],
            mortgages: ["interventionType"],
            loans: ["interventionType"],
            wallet: ["intervenerType"],
            deposits: ["interventionType"],
            pregrantedcredit: ["interventionType"],
        }

        const breadcrumbByType = {
            account: ["alias"],
            cards: ["alias", "current"],
            mortgages: ["alias"],
            loans: ["alias"],
            wallet: ["name"],
            deposits: ["alias"],
        }

        const contractNumber = this.getContractNumber(contractType)
        const accountHolder = immData.getIn(accountHolderByType[contractType]) || immData.get("holder")
        const interventionType = immData.getIn(interventionTypeByType[contractType])
        const mappingBreadcrumb =
            contractType !== "pregrantedcredit"
                ? this.getBreadCrumb(
                    immData.getIn(breadcrumbByType[contractType]) || contractNumber,
                )
                : this.getBreadCrumb(`${formatText("profileDocumentation-pregrantedcreditTitle")}`)
        const currentDocumentTable = this.getCurrentDocumentTable()
        const subtitleHeader = formatText(
            "profileContract-aliasHeader",
            contractType !== "pregrantedcredit"
                ? [
                    immData.getIn(subtitleHeaderByType[contractType])
                        ? immData.getIn(subtitleHeaderByType[contractType])
                        : contractNumber,
                ]
                : [`${formatText("profileDocumentation-pregrantedcreditTitle")}`],
        )
        const documentationCenterItem = this.buildDocumentationCenterItem()

        return (
            <React.Fragment>
                <div className='container-fluid'>
                    <div className='row'>
                        <OKCover size='medium' section='pg' customClass='col-xs-12'>
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle("breadcrumb-contracts")}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className='grid-view__body'>
                    <div className='container-fluid'>
                        <div className='row grid-view--content-position-negative'>
                            <div className='col-xs-12'>
                                <OKSectionBox title={subtitleHeader}>
                                    <div className='contract-view__box-data'>
                                        <OKInformativeList columns={2}>
                                            <OKInformativeListItem
                                                title={formatText("profileContract-contractNumber")}
                                                bodyText={contractNumber}
                                            />
                                            <OKInformativeListItem
                                                title={formatText("profileContract-clientName")}
                                                bodyText={accountHolder}
                                            />
                                            <OKInformativeListItem
                                                title={formatText("profileContract-interventionType")}
                                                bodyText={formatTextApi("profileContract-interventionType", interventionType)}
                                            />
                                        </OKInformativeList>
                                    </div>
                                    {documentationCenterItem}
                                    <div className='contract-view__contract'>
                                        <h3 className='contract-view__title'>
                                            <FormattedText value='profileContract-contractTitle' />
                                        </h3>
                                        {this.generateDocumentsTableContent()}
                                    </div>
                                    {currentDocumentTable}
                                </OKSectionBox>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

MyProfileDocumentationContractView.defaultProps = {
    immContract: Immutable.fromJS([]),
}

MyProfileDocumentationContractView.propTypes = {
    immContract: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immSadde: PropTypes.object.isRequired,
    immOkApiDocuments: PropTypes.object,
    immLoans: PropTypes.object.isRequired,
    immSavings: PropTypes.object.isRequired,
    immWallets: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsCanceled: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    requestDeposits: PropTypes.func.isRequired,
    getSaddeDocuments: PropTypes.func.isRequired,
    getCardsIban: PropTypes.func.isRequired,
    getLoansIban: PropTypes.func.isRequired,
    getPreContractuals: PropTypes.func.isRequired,
    getPreContractualsOkApi: PropTypes.func,
    getDocumentsOkApiById: PropTypes.func,
    getFileSaddeDocuments: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    getContractualOverdraftProtection: PropTypes.func.isRequired,
    updateIsFetchingOverdraftInProgress: PropTypes.func.isRequired,
    updateIsFetchingOverdraftFinish: PropTypes.func.isRequired,
}

module.exports = MyProfileDocumentationContractView
module.exports.MyProfileDocumentationContractView = withRouter(connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immCardsCanceled: state.cardsCanceled,
        immWallets: state.brokerWallets.get("walletList"),
        immFunds: state.brokerWallets.get("fundsList"),
        immSavings: state.globalPosition.getIn(["savings", "data"]),
        immDeposits: state.deposits,
        immLoans: state.loans,
        immSadde: state.sadde,
        immOkApiDocuments: state.okApiDocuments,
    }),
    {
        getSaddeDocuments: saddeActions.getSaddeDocuments,
        getCardsIban: saddeActions.getCardsIban,
        getLoansIban: saddeActions.getLoansIban,
        getPreContractuals: saddeActions.getPreContractuals,
        getPreContractualsOkApi: okApiDocumentsActions.getPreContractualsOkApi,
        getDocumentsOkApiById: okApiDocumentsActions.getDocumentsOkApiById,
        getContractualOverdraftProtection: okApiDocumentsActions.getContractualOverdraftProtection,
        updateIsFetchingOverdraftInProgress: okApiDocumentsActions.updateIsFetchingOverdraftInProgress,
        updateIsFetchingOverdraftFinish: okApiDocumentsActions.updateIsFetchingOverdraftFinish,
        getFileSaddeDocuments: saddeActions.getFileSaddeDocuments,
        requestDeposits: depositsActions.requestDeposits,
    },
)(MyProfileDocumentationContractView))
